import { usePrivy, useWallets as usePrivyWallets } from '@privy-io/react-auth';
import { useConnectedStandardWallets, useExportWallet } from '@privy-io/react-auth/solana';
import { useEffect, useMemo } from 'react';
import { privyAdapter } from '../../adapter';
import { buildProvider } from '../../wallet/provider';
import { checkIsPrivyReadyForConnect } from '../../wallet/utils';
export function useSocialWallet() {
    const { user, login, logout, ready, exportWallet: exportEvmWallet } = usePrivy();
    const { wallets: privyEvmWallets } = usePrivyWallets();
    const { wallets: privySolanaWallets } = useConnectedStandardWallets();
    const { exportWallet: exportSolanaWallet } = useExportWallet();
    useMemo(() => {
        if (!!privyAdapter.provider) {
            return privyAdapter.provider;
        }
        return buildProvider();
    }, [privyAdapter.provider]);
    const handleConnect = (provider) => {
        const evmNamespace = provider.get('evm');
        const isEvmNamespaceConnected = evmNamespace?.state()[0]('connected');
        if (evmNamespace && !isEvmNamespaceConnected) {
            void evmNamespace.connect();
        }
        const solanaNamespace = provider.get('solana');
        const isSolanaNamespaceConnected = solanaNamespace?.state()[0]('connected');
        if (solanaNamespace && !isSolanaNamespaceConnected) {
            void solanaNamespace.connect();
        }
    };
    const handleDisconnect = (provider) => {
        const evmNamespace = provider.get('evm');
        const isEvmNamespaceConnected = evmNamespace?.state()[0]('connected');
        if (evmNamespace && isEvmNamespaceConnected) {
            void evmNamespace.disconnect();
        }
        const solanaNamespace = provider.get('solana');
        const isSolanaNamespaceConnected = solanaNamespace?.state()[0]('connected');
        if (solanaNamespace && isSolanaNamespaceConnected) {
            void solanaNamespace.disconnect();
        }
    };
    useEffect(() => {
        const privyContext = {
            ready,
            user,
            login,
            logout,
            privySolanaWallets,
            privyEvmWallets,
        };
        privyAdapter.setPrivyContext(privyContext);
        const provider = privyAdapter.getProvider();
        const isHubProviderInitiated = privyAdapter.getIsProviderInitiated();
        if (!!provider && isHubProviderInitiated) {
            const isProviderConnected = provider.state()[0]('connected');
            const isPrivyReadyForConnect = checkIsPrivyReadyForConnect(privyContext);
            if (!isProviderConnected && isPrivyReadyForConnect) {
                handleConnect(provider);
            }
            if (isProviderConnected && !privyContext.user) {
                handleDisconnect(provider);
            }
        }
    }, [ready, privyEvmWallets, login, user, privySolanaWallets, logout]);
    return {
        getSocialUser: () => privyAdapter.getPrivyContext().user,
        exportEvmWallet: exportEvmWallet,
        exportSolanaWallet: exportSolanaWallet,
        provider: privyAdapter.provider,
    };
}
